var localizedFormat = { exports: {} };
export {
  localizedFormat as __module
};
//# sourceMappingURL=localizedFormat2.js.map
